export default __webpack_public_path__ + "static/media/tfg_mainlogo.fb843daa.svg";